const displayModal = (elementId) => {
  const modal = new bootstrap.Modal(document.getElementById(elementId));
  modal.show();
};

export default displayModal;
